import { render, staticRenderFns } from "./bolumcomp.vue?vue&type=template&id=66c50711&"
import script from "./bolumcomp.vue?vue&type=script&lang=js&"
export * from "./bolumcomp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports